// src/components/ChangeLangButton.tsx
type Props = {
  isDanish: boolean;
  setIsDanish: (val: boolean) => void;
};

export default function ChangeLangButton({ isDanish, setIsDanish }: Props) {
  return (
    <button
      type="button"
      onClick={() => setIsDanish(!isDanish)}
      className="cv-button mb-4 w-max"
    >
      {isDanish ? "Switch to English" : "Skift til Dansk"}
    </button>
  );
}
